import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  integrationTransactionsCollection: string = "IntegrationTransactions";
  constructor(private firestore: AngularFirestore) {}

  transactionDocumentReference(transactionId: string, superTransactionId: string | null = null) {
    if (superTransactionId) {
      return this.firestore.collection(this.integrationTransactionsCollection).doc(superTransactionId).collection(this.integrationTransactionsCollection).doc(transactionId);
    }
    else {
      return this.firestore.collection(this.integrationTransactionsCollection).doc(transactionId);
    }
  }
}
